export const API_URL = import.meta.env.VITE_API_URL || "https://api.amoozim.com/api";
export const APP_URL = import.meta.env.VITE_APP_URL || "https://amoozim.com";
export const STORAGE_API_BASE = import.meta.env.VITE_STORAGE_API_BASE || "https://storage.amoozim.com/api";
export const STORAGE_PREVIEW_BASE = import.meta.env.VITE_STORAGE_PREVIEW_BASE || "https://storage.amoozim.com";
export const EITAA_BASE_URL = import.meta.env.VITE_EITAA_BASE_URL || "https://eitaa.com";
export const EITAA_MIMIAPP_DIRECT_URL = import.meta.env.VITE_EITAA_MIMIAPP_DIRECT_URL || "https://eitaa.com/amoozim_app/direct";
export const ANALYTICS_SOURCE = import.meta.env.VITE_ANALYTICS_SOURCE || "vitrin";
export const SUPPORT_EITAA_USERNAME =
  import.meta.env.VITE_SUPPORT_EITAA_USERNAME || "amoozim_admin";
export const SUPPORT_PHONE =
  import.meta.env.VITE_SUPPORT_PHONE || "02191090362";

export const EDUCATORS_EITAA_LINK = `https://eitaa.com/amoozim_creator_app/app`;  

export const INSTALMENT_ENABLED = true;

// Cheapest course price (Toman) that still gets the installment hint on course
// cards. Below it, splitting into 4 leaves an amount too small to be worth the
// badge. Read via `Number()` so an unset/blank/garbage env falls back instead
// of silently becoming 0 (which would show the badge on every paid course).
const rawMinInstalmentValue = 50000;
// const rawMinInstalmentValue = import.meta.env.VITE_MIN_INSTALMENT_VALUE;
export const MIN_INSTALMENT_VALUE =
  rawMinInstalmentValue && Number.isFinite(Number(rawMinInstalmentValue))
    ? Number(rawMinInstalmentValue)
    : 500000;
